/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as References from './LearningPathChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#get
 */
export const GET_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'get',
  args: ['playlistId'],
  fetcher(request) {
    return chirpClient.call(References.getRpc, {
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#getPlaylistOrLearningPath
 */
export const GET_PLAYLIST_OR_LEARNING_PATH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'getPlaylistOrLearningPath',
  args: ['playlistId'],
  fetcher(request) {
    return chirpClient.call(References.getPlaylistOrLearningPathRpc, {
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#getAllPaginated
 */
export const GET_ALL_PAGINATED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'getAllPaginated',
  args: ['pageLength', 'offset'],
  fetcher(request) {
    return chirpClient.call(References.getAllPaginatedRpc, {
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#getLearningPaths
 */
export const GET_LEARNING_PATHS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'getLearningPaths',
  args: ['learningPathIds'],
  fetcher(request) {
    return chirpClient.call(References.getLearningPathsRpc, {
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#getSimpleLearningPathsOrPlaylists
 */
export const GET_SIMPLE_LEARNING_PATHS_OR_PLAYLISTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'getSimpleLearningPathsOrPlaylists',
  args: ['playlistIds'],
  fetcher(request) {
    return chirpClient.call(References.getSimpleLearningPathsOrPlaylistsRpc, {
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#getAllPaginatedInternal
 */
export const GET_ALL_PAGINATED_INTERNAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'getAllPaginatedInternal',
  args: ['pageLength', 'offset'],
  fetcher(request) {
    return chirpClient.call(References.getAllPaginatedInternalRpc, {
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#create
 */
export const CREATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: 'create',
  args: ['name', 'description', 'thumbnailRectangleUrl', 'thumbnailSquareUrl', 'internalName', 'visibility', 'difficulty', 'active', 'items', 'language'],
  fetcher(request) {
    return chirpClient.call(References.createRpc, {
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#createFromPlaylist
 */
export const CREATE_FROM_PLAYLIST_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: 'createFromPlaylist',
  args: ['name', 'description', 'thumbnailRectangleUrl', 'thumbnailSquareUrl', 'playlistId', 'internalName', 'visibility', 'difficulty', 'active', 'language'],
  fetcher(request) {
    return chirpClient.call(References.createFromPlaylistRpc, {
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#update
 */
export const UPDATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: 'update',
  args: ['playlistId', 'name', 'description', 'thumbnailSquareUrl', 'thumbnailRectangleUrl', 'internalName', 'visibility', 'difficulty', 'active', 'language', 'items', 'hiddenForOwner'],
  fetcher(request) {
    return chirpClient.call(References.updateRpc, {
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService#delete
 */
export const DELETE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: 'delete',
  args: ['playlistId'],
  fetcher(request) {
    return chirpClient.call(References.deleteRpc, {
      request
    });
  }
});